(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alb-filter-info"] && !Shopify.designMode) return;
  try {
    
  /* Scroll-Fade der Vergleichstabelle: Kanten-Klassen je Scroll-Position setzen.
     Idempotent (data-Flag) und erneut bei Editor-Rerender (shopify:section:load). */
  (function () {
    function initAlbSfiFades(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.alb-sfi-scroll').forEach(function (el) {
        if (el.dataset.albFadeInit) return;
        el.dataset.albFadeInit = '1';
        function update() {
          var max = el.scrollWidth - el.clientWidth;
          el.classList.toggle('alb-sfi-fade-l', el.scrollLeft > 2);
          el.classList.toggle('alb-sfi-fade-r', el.scrollLeft < max - 2);
        }
        el.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
      });
    }
    initAlbSfiFades(document);
    document.addEventListener('shopify:section:load', function (e) { initAlbSfiFades(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alb-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__albHeaderInit) return;
  window.__albHeaderInit = true;
  function init() {
    var mm = document.querySelector('.mega-menu');
    if (!mm) return;
    // i18n-Bridge: Texte + locale-aware Root aus dem <script>-Block (Liquid) lesen, mit Fallback.
    var __i18n = window.__albHeaderI18n || {};
    function ALBH_T(k){ return Object.prototype.hasOwnProperty.call(__i18n, k) ? __i18n[k] : k; }
    function ALBH_URL(p){ var r = window.__albHeaderRoot || ''; return (p && p.charAt(0) === '/') ? r + p : p; }
var searchResults = document.querySelectorAll(".search-results");
var originalContent = searchResults[0].innerHTML;
var clearSearchIcon = document.querySelectorAll(".mega-menu .clear-search");
var searchTimeout;
var searchInput = document.querySelector(".search-input");
var searchInputDesktop = document.querySelector(".menu-desktop .search-form input");

searchInputDesktop.addEventListener("keypress", function (e) {
    // Überprüfen, ob die Enter-Taste gedrückt wurde
    if (e.key === "Enter") {
        e.preventDefault(); // Verhindern, dass das Formular auf traditionelle Weise gesendet wird
        var searchQuery = this.value; // Wert des Sucheingabefeldes
        var searchUrl = "/search?q=" + encodeURIComponent(searchQuery); // Erstellen der Such-URL
        window.location.href = searchUrl; // Umleitung des Benutzers auf die Such-URL
    }
});

if (searchInput.form) {
    searchInput.form.addEventListener("submit", function (event) {
        event.preventDefault();
        searchInput.blur(); // Entfernt den Fokus vom Eingabeelement
    });
}

// MOBILE :: Öffnen des Menüs
document.querySelector(".menu-mobile .burger-menu-icon").addEventListener("click", function () {
    const mobilemenuactive = document.querySelector(".menu-mobile .dropdown").classList.contains("active");
    this.parentElement.parentElement.querySelector(".dropdown").classList.toggle("active");
    if (!mobilemenuactive) {
        //document.body.style.overflow = "hidden";
        this.querySelector(".burger").style.display = "none";
        this.querySelector(".xmark").style.display = "block";
    } else {
        //document.body.style.overflow = "auto";
        this.querySelector(".burger").style.display = "block";
        this.querySelector(".xmark").style.display = "none";
    }
});

// MOBILE :: Suchfeld öffnen
document.querySelector(".search-mobile").addEventListener("click", function (e) {
    // href="#" nicht ausführen: sonst springt die Seite nach oben, die URL bekommt ein „#“ und die
    // Seitenwechsel-Listener von Meta/Google/Statsig zählen einen zusätzlichen Seitenaufruf (INP + Daten).
    e.preventDefault();
    var searchForm = document.querySelector(".menu-mobile .search-form");
    searchForm.classList.toggle("active");
    //close menu dropdown if active
    document.querySelector(".menu-mobile .dropdown").classList.remove("active");

    if (searchForm.classList.contains("active")) {
        var searchInput = searchForm.querySelector("input");
        if (searchInput) {
            searchInput.focus();
        }
    } else {
    }
});

// MOBILE :: Schließen des Suchfelds
document.querySelector(".close-search").addEventListener("click", function (event) {
    event.stopPropagation();
    var searchForm = document.querySelector(".menu-mobile .search-form");
    searchForm.classList.remove("active");
});

// Suchvorschläge MOBILE und DESKTOP
var searchInput = document.querySelectorAll(".search-input");
searchInput.forEach(function (input) {
    input.addEventListener("input", function () {
        var searchQuery = this.value;
        clearTimeout(searchTimeout);
        if (searchQuery.length >= 1) {
            for (var i = 0; i < clearSearchIcon.length; i++) clearSearchIcon[i].style.display = "block";
        } else {
            for (var i = 0; i < clearSearchIcon.length; i++) clearSearchIcon[i].style.display = "none";
        }

        if (searchQuery.length >= 3) {
            // Spinner anzeigen
            startSpinner();
            // Leeren Sie die aktuellen Suchergebnisse
            for (var i = 0; i < searchResults.length; i++) {
                searchResults[i].innerHTML = "";
            }

            searchTimeout = setTimeout(function () {
                // ALB (2026-09-17): Ratgeber-Treffer zusaetzlich ueber das Artikel-Metafeld
                // alb.suchbegriffe (Section alb-such-ratgeber-json, Liquid-Matching) holen und
                // dedupliziert vor die Shopify-Artikeltreffer mischen. Fehler => nur Shopify-Treffer.
                var albRatgeberFetch = fetch(ALBH_URL("/search?q=" + encodeURIComponent(searchQuery) + "&section_id=alb-such-ratgeber-json"))
                    .then(function (r) { return r.ok ? r.text() : ""; })
                    .then(function (html) {
                        var m = /<script[^>]*data-alb-such-ratgeber[^>]*>([\s\S]*?)<\/script>/.exec(html || "");
                        return m ? JSON.parse(m[1]) : [];
                    })
                    .catch(function () { return []; });
                Promise.all([
                    fetch("/search/suggest.json?q=" + encodeURIComponent(searchQuery) + "&resources[type]=product,page,article,collection,query&resources[options][fields]=variants.sku,title,tag")
                        .then((response) => response.json()),
                    albRatgeberFetch
                ])
                    .then(function (both) {
                        var data = both[0], extra = both[1] || [];
                        try {
                            var list = (data.resources.results.articles || []).slice();
                            var seen = {};
                            list.forEach(function (a) { seen[(a.url || "").split("?")[0]] = true; });
                            extra.forEach(function (a) {
                                var key = (a.url || "").split("?")[0];
                                if (key && !seen[key]) { seen[key] = true; list.push({ title: a.title, url: a.url, image: a.image }); }
                            });
                            data.resources.results.articles = list;
                        } catch (e) { /* Merge-Fehler ignorieren, Shopify-Treffer bleiben */ }
                        return data;
                    })
                    .then((data) => {
                        // Spinner ausblenden
                        stopSpinner();
                        // Fügen Sie die neuen Suchergebnisse hinzu
                        let foundResults = false;
                        ["products", "articles", "pages", "collections"].forEach(function (resultType) {
                            var results = data.resources.results[resultType]; // get the results for the current type
                            if (results.length > 0) {
                                foundResults = true;
                                var resultsWrapper = document.createElement("div");
                                resultsWrapper.className = `search-results-wrapper-${resultType}`;

                                results.forEach(function (result) {
                                    var resultElement = document.createElement("a");
                                    resultElement.href = result.url;
                                    resultElement.className = "search-result";
                                    resultElement.classList.add(`search-result-${resultType}`);

                                    // Bild des Produkts wenn vorhanden
                                    if (resultType === "products" && result.image) {
                                        var imgElement = document.createElement("img");
                                        imgElement.src = result.image;
                                        resultElement.appendChild(imgElement);
                                    }

                                    var titleElement = document.createElement("div");
                                    titleElement.className = "search-result-title";
                                    titleElement.innerHTML = `<p>${result.title}</p>`;
                                    if (resultType === "pages") {
                                        titleElement.innerHTML += "<p class='info'>" + ALBH_T("badge_info_page") + "</p>";
                                        resultElement.appendChild(titleElement);
                                    }
                                    if (resultType === "articles") {
                                        titleElement.innerHTML += "<p class='info'>" + ALBH_T("badge_ratgeber") + "</p>";
                                        resultElement.appendChild(titleElement);
                                    }
                                    if (resultType === "collections") {
                                        titleElement.innerHTML += "<p class='info'>" + ALBH_T("badge_shop_cat") + "</p>";
                                        resultElement.appendChild(titleElement);
                                    }

                                    if (resultType === "products") {
                                        var nameElement = document.createElement("div");
                                        nameElement.className = "search-result-name";
                                        nameElement.textContent = `${result.title}`;
                                        resultElement.appendChild(nameElement);

                                        var priceElement = document.createElement("div");
                                        priceElement.className = "search-result-price";
                                        // Setzen Sie den Preis des Produkts, z.B. priceElement.textContent = result.price;
                                        priceElement.textContent = `${ALBH_T("price_from")} ${result.price_min} EUR`;
                                        resultElement.appendChild(priceElement);
                                    }

                                    resultsWrapper.appendChild(resultElement);
                                });

                                // Fügen die Ergebnisse in die Suchergebnisse ein
                                for (var i = 0; i < searchResults.length; i++) {
                                    if (resultsWrapper.hasChildNodes()) {
                                        var clone = resultsWrapper.cloneNode(true);
                                        searchResults[i].appendChild(clone);
                                    }
                                }
                            }
                        });
                        // Wenn keine Ergebnisse gefunden wurden, fügen Sie eine Meldung hinzu
                        if (!foundResults) {
                            for (var i = 0; i < searchResults.length; i++) {
                                searchResults[i].innerHTML = "<p class='no-results'>" + ALBH_T("no_results").replace("%q%", '<span style="font-style: italic; font-weight: bold">' + searchQuery + '</span>') + "</p>";
                            }
                        }
                    })
                    .catch((error) => {
                        stopSpinner();
                        console.error("Fehler:", error);
                    });
            }, 1000);
        } else if (searchQuery.length === 0) {
            // Wenn das Eingabefeld gelöscht wird, stellen Sie den ursprünglichen Inhalt wieder her
            for (var i = 0; i < searchResults.length; i++) {
                searchResults[i].innerHTML = originalContent;
            }
        }
    });
});

// Löschen des Suchfelds MOBILE und DESKTOP
for (var i = 0; i < clearSearchIcon.length; i++) {
    clearSearchIcon[i].addEventListener("click", function () {
        const si = document.querySelectorAll(".search-input");
        for (var j = 0; j < si.length; j++) si[j].value = "";

        this.style.display = "none";
        for (var i = 0; i < searchResults.length; i++) searchResults[i].innerHTML = originalContent;
    });
}

// MOBILE :: Dropdown Mobile
var toggles = document.querySelectorAll(".menu-mobile .accordion-toggle");
toggles.forEach(function (toggle) {
    toggle.addEventListener("click", function (e) {
        // Überprüfen, ob das geklickte Element (oder ein Elternelement davon) das accordion-content ist
        var target = e.target;
        while (target != null) {
            if (target.classList.contains("accordion-content")) {
                return; // Beenden Sie die Ausführung der Funktion, wenn das geklickte Element das accordion-content ist
            }
            target = target.parentElement;
        }

        e.preventDefault();

        // Schließe alle anderen Dropdowns
        toggles.forEach(function (otherToggle) {
            if (otherToggle !== toggle) {
                var title = otherToggle.querySelector(".dd-menu a");
                var otherContent = otherToggle.querySelector(".accordion-content");
                var otherIconCaretRight = otherToggle.querySelector(".caret-right");
                var otherIconCaretDown = otherToggle.querySelector(".caret-down");
                if (otherContent.classList.contains("active")) {
                    title.classList.remove("bold");
                    otherContent.classList.remove("active");
                    otherIconCaretRight.style.display = "block";
                    otherIconCaretDown.style.display = "none";
                }
            }
        });

        var content = this.querySelector(".accordion-content");
        var iconCaretRight = this.querySelector(".caret-right");
        var iconCaretDown = this.querySelector(".caret-down");
        var title = this.querySelector(".dd-menu a");

        if (content.classList.contains("active")) {
            title.classList.remove("bold");
            content.classList.remove("active");
            iconCaretRight.style.display = "block";
            iconCaretDown.style.display = "none";
        } else {
            title.classList.add("bold");
            content.classList.add("active");
            iconCaretRight.style.display = "none";
            iconCaretDown.style.display = "block";
        }
    });
});

// DESKTOP // DESKTOP // DESKTOP // DESKTOP // DESKTOP // DESKTOP // DESKTOP
// DESKTOP // DESKTOP // DESKTOP // DESKTOP // DESKTOP // DESKTOP // DESKTOP

window.addEventListener("scroll", () => {
    handleMenuScroll();
});

const handleMenuScroll = () => {
    document.querySelectorAll("[data-dropdown].active").forEach(function (dropdown) {
        dropdown.classList.remove("active");
        document.querySelector("#alb-curtain").classList.remove("active");
    });
};

// DESKTOP :: Horizon scrollt ab 990 px in .page-wrapper, nicht in window – Scroll dort per Capture abfangen
// (Scrolls innerhalb der Navi, z. B. Mobil-Menü/Suchergebnisse, bleiben unberücksichtigt)
document.addEventListener("scroll", function (e) {
    var t = e.target;
    if (t && t !== document && t.closest && t.closest("nav.alb-header")) return;
    handleMenuScroll();
}, true);

// DESKTOP :: Mausrad über dem aktiven Vorhang: position:fixed hängt in Safari nicht in der Scroll-Kette von
// .page-wrapper, das Rad bewegte dort nichts. Delta selbst an den Scroll-Container geben und Menü schließen.
(function () {
    var curtain = document.querySelector("#alb-curtain");
    if (!curtain) return;
    curtain.addEventListener("wheel", function (e) {
        var pw = document.querySelector(".page-wrapper");
        var scroller = (pw && /auto|scroll/.test(getComputedStyle(pw).overflowY)) ? pw : document.scrollingElement;
        var f = e.deltaMode === 1 ? 16 : (e.deltaMode === 2 ? window.innerHeight : 1);
        e.preventDefault();
        try { scroller.scrollBy({ top: e.deltaY * f, left: e.deltaX * f, behavior: "instant" }); }
        catch (err) { scroller.scrollTop += e.deltaY * f; }
        handleMenuScroll();
    }, { passive: false });
    curtain.addEventListener("click", function () { handleMenuScroll(); });
})();

// DESKTOP :: Öffnen des Dropdowns beim Überfahren des Buttons
document.querySelectorAll("[data-dropdown-button]").forEach(function (dropdown) {
    dropdown.addEventListener("mouseover", function () {
        // Offset der Linkliste bei jedem Öffnen neu berechnen (Layout kann sich ohne resize-Event ändern,
        // z. B. offener Cart-Drawer beim Laden, Font-Swap, Zoom)
        if (typeof albLayoutDropdowns === "function") albLayoutDropdowns();
        var ownDropdown = this.closest("[data-dropdown]");
        var navEl = this.closest("nav.alb-header");
        // Direkter Wechsel zwischen zwei offenen Hauptpunkten: Übergänge kurz abschalten, sonst blitzt es
        // (altes Panel blendet aus, neues blendet ein). Klasse wird nach dem Frame wieder entfernt.
        var otherOpen = false;
        document.querySelectorAll("[data-dropdown].active").forEach(function (dropdown) {
            if (dropdown !== ownDropdown) { otherOpen = true; dropdown.classList.remove("active"); }
        });
        if (otherOpen && navEl) {
            navEl.classList.add("alb-dd-switch");
            clearTimeout(window.__albDdSwitchT);
            window.__albDdSwitchT = setTimeout(function () { navEl.classList.remove("alb-dd-switch"); }, 80);
        }

        // Öffnen des aktuellen Dropdowns
        ownDropdown.classList.add("active");
        // Kein Vorhang mehr für Dropdowns (kompaktes Menü, 2026-09-17) – der Curtain bleibt nur fürs Suchfeld.

        // Schließen des Suchformulars beim Hovern über ein Dropdown
        var searchForm = document.querySelector(".menu-desktop .search-form");
        if (searchForm.classList.contains("active")) {
            searchForm.classList.remove("active");
            document.querySelector("#alb-curtain").classList.remove("active");
        }
    });
});

// DESKTOP :: Hauptpunkte ohne eigenes Ziel (href="#", z. B. Service): Klick nicht zum Seitenanfang springen
// lassen – der Hash-Sprung ließ das offene Dropdown kurz verschwinden (ClickUp 41)
document.querySelectorAll('.menu-desktop .dropdown > a[href="#"]').forEach(function (a) {
    a.addEventListener("click", function (e) { e.preventDefault(); });
});

// DESKTOP :: Schließen aller Dropdowns beim Hovern über SingleLink (wie Ratgeber)
document.querySelectorAll(".menu-desktop .menu-left > .link, .menu-desktop .menu-right > .link").forEach(function (link) {
    link.addEventListener("mouseover", function () {
        document.querySelectorAll("[data-dropdown].active").forEach(function (dropdown) {
            dropdown.classList.remove("active");
        });
        document.querySelector("#alb-curtain").classList.remove("active");
    });
});

// DESKTOP :: Schließen des Dropdowns beim Verlassen des Menüs
document.querySelectorAll(".dropdown-menu").forEach(function (dropdownMenu) {
    dropdownMenu.addEventListener("mouseleave", function (e) {
        // Maus wandert zurück auf einen Hauptpunkt (eigenen oder anderen): offen lassen bzw. den
        // mouseover des Ziel-Buttons wechseln lassen – sonst Schließen+Öffnen mit Blitzen
        var to = e.relatedTarget;
        if (to && to.closest && to.closest(".menu-desktop [data-dropdown]")) return;
        // Schließen des aktuellen Dropdowns
        this.closest("[data-dropdown]").classList.remove("active");

        // if no dropdown is active
        if (document.querySelectorAll("[data-dropdown].active").length === 0) {
            document.querySelector("#alb-curtain").classList.remove("active");
        }
    });
});

// DESKTOP :: Suchfeld öffnen
document.querySelector(".menu-desktop .search-desktop").addEventListener("click", function (e) {
    e.preventDefault();
    var searchForm = document.querySelector(".menu-desktop .search-form");

    // Schließen aller aktiven Dropdowns
    document.querySelectorAll("[data-dropdown].active").forEach(function (dropdown) {
        dropdown.classList.remove("active");
    });

    searchForm.classList.toggle("active");
    var searchInput = searchForm.querySelector("input");
    if (searchInput) {
        searchInput.focus();
    }
    // if search form is active, set body overflow to "hidden", otherwise set it to "auto"
    // document.body.style.overflow = searchForm.classList.contains("active") ? "hidden" : "auto";
    if (searchForm.classList.contains("active")) {
        document.querySelector("#alb-curtain").classList.add("active");
    } else {
        document.querySelector("#alb-curtain").classList.remove("active");
    }
});

document.addEventListener("click", function (e) {
    var megaMenu = document.querySelector(".mega-menu");
    var searchForm = document.querySelector(".menu-desktop .search-form");
    if (!megaMenu.contains(e.target) && searchForm.classList.contains("active")) {
        // Search Form schließen
        searchForm.classList.remove("active");
        // Alb Curtain entfernen
        document.querySelector("#alb-curtain").classList.remove("active");
        // Alle Dropdowns schließen
        document.querySelectorAll("[data-dropdown].active").forEach(function (dropdown) {
            dropdown.classList.remove("active");
        });
    }
});

// DESKTOP :: Dropdown-Layout: Liste unter dem Hauptpunkt ausrichten (--alb-dd-offset).
// Läuft beim Init, nach dem Font-Laden und bei Resize.
function albLayoutDropdowns() {
    var navEl = document.querySelector("nav.alb-header");
    if (!navEl) return;
    var dds = navEl.querySelectorAll(".menu-desktop [data-dropdown]");
    if (!dds.length) return;
    var navLeft = navEl.getBoundingClientRect().left;
    dds.forEach(function (dd) {
        var btn = dd.querySelector("[data-dropdown-button]");
        var menu = dd.querySelector(".dropdown-menu");
        if (!btn || !menu) return;
        var off = btn.getBoundingClientRect().left - navLeft + (parseFloat(getComputedStyle(btn).paddingLeft) || 0);
        menu.style.setProperty("--alb-dd-offset", Math.max(0, Math.round(off)) + "px");
    });
}
albLayoutDropdowns();
if (document.fonts && document.fonts.ready) document.fonts.ready.then(albLayoutDropdowns);
window.addEventListener("resize", function () {
    clearTimeout(window.__albDdLayoutT);
    window.__albDdLayoutT = setTimeout(albLayoutDropdowns, 150);
}, { passive: true });


// HELPER FUNCTIONS

function startSpinner() {
    const spinner = document.querySelectorAll(".search-spinner");
    for (var i = 0; i < spinner.length; i++) {
        spinner[i].style.display = "block";
    }
}

function stopSpinner() {
    const spinner = document.querySelectorAll(".search-spinner");
    for (var i = 0; i < spinner.length; i++) {
        spinner[i].style.display = "none";
    }
}

function lockBody() {
    console.log("locked " + uuid());
    // Breite des Scrollbalkens berechnen
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Scrollen verhindern und Platz für Scrollbalken ausgleichen
    document.body.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
    document.body.classList.add("locked");
}

function unlockBody() {
    console.log("unlocked " + uuid());
    // Entferne die Scroll-Blockierung und den Scrollbalkenausgleich
    document.body.style.removeProperty("--scrollbar-width");
    document.body.classList.remove("locked");
}

function uuid() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) => (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16));
}


// --- Sticky Header (aus header_alb.js, auf .alb-header umgestellt) ---
// Horizon scrollt ab 990 px in .page-wrapper (window.scrollY bleibt 0), darunter im Dokument;
// beide Quellen werden addiert, eine ist immer 0. Jenseits ihrer natuerlichen Oberkante wird
// die Navi position:fixed (CSS .sticky_nav), faehrt beim Runterscrollen raus und beim
// Hochscrollen nur bei zuegiger Bewegung (SHOW_UP_PX innerhalb SHOW_UP_MS) oder kurz vor der
// Ausgangsposition wieder rein. html.alb-header-shown + --alb-header-offset (0 bzw. Navi-Hoehe):
// die Sticky-Kaufleiste weicht dem eingeblendeten Menue, die PDP-Sprungleiste rueckt darunter.
(function () {
  var navbar = document.querySelector('nav.alb-header');
  if (!navbar) return;
  var SHOW_UP_PX = 90;   // so viele Pixel hoch ...
  var SHOW_UP_MS = 300;  // ... innerhalb dieser Zeit -> Navi faehrt raus
  var HIDE_DOWN_PX = 8;  // kleines Zittern beim Runterscrollen ignorieren
  var wrap = navbar.closest('.shopify-section') || navbar.parentElement;
  var pw = document.querySelector('.page-wrapper');
  var root = document.documentElement;
  var h = 60, sc = document.scrollingElement || root, state = 'flow', lastY = null, downAcc = 0, ups = [], raf = 0, rt;

  function measure() {
    h = navbar.offsetHeight || 60;
    sc = (pw && /auto|scroll/.test(getComputedStyle(pw).overflowY)) ? pw : (document.scrollingElement || root);
    wrap.style.minHeight = h + 'px'; // Platzhalter, sobald die Navi den Fluss verlaesst
    // clientWidth ist 0, solange das Dokument nicht gerendert wurde (Hintergrund-Tab, Prerender) -> dann 100 %
    var w = sc === pw ? pw.clientWidth : 0;
    navbar.style.setProperty('--alb-header-fixed-w', w > 0 ? w + 'px' : '100%');
  }
  function setState(next, animate) {
    if (next === state) return;
    navbar.style.transition = animate ? '' : 'none';
    if (next === 'flow') {
      navbar.classList.remove('sticky_nav', 'hidden_nav', 'show_nav');
    } else {
      navbar.classList.add('sticky_nav');
      navbar.classList.toggle('hidden_nav', next === 'hidden');
      navbar.classList.toggle('show_nav', next === 'shown');
    }
    state = next;
    root.classList.toggle('alb-header-shown', next === 'shown');
    root.style.setProperty('--alb-header-offset', next === 'shown' ? h + 'px' : '0px');
  }
  function handle() {
    raf = 0;
    var y = (pw ? pw.scrollTop : 0) + (window.scrollY || 0);
    var maxY = sc.scrollHeight - sc.clientHeight;
    if (y > maxY) y = maxY; // iOS-Bounce am Seitenende
    if (y < 0) y = 0;
    if (lastY === null) lastY = y;
    var natTop = wrap.getBoundingClientRect().top + y; // natuerliche Oberkante der Navi
    var dy = y - lastY, now = performance.now();
    lastY = y;
    if (y <= natTop) { setState('flow', false); ups.length = 0; downAcc = 0; return; }
    if (state === 'flow') {
      // Einklinken: Masse frisch nehmen, jenseits der eigenen Hoehe unsichtbar starten, sonst sichtbar (kein Sprung)
      measure();
      setState(y > natTop + h ? 'hidden' : 'shown', false);
      ups.length = 0; downAcc = 0; return;
    }
    if (dy > 0) {
      ups.length = 0; downAcc += dy;
      if (state === 'shown' && y > natTop + h && downAcc >= HIDE_DOWN_PX) setState('hidden', true);
    } else if (dy < 0) {
      downAcc = 0;
      while (ups.length && now - ups[0][0] > SHOW_UP_MS) ups.shift(); // nur das juengste Zeitfenster zaehlt
      if (!ups.length) ups.push([now - 1, y - dy]); // Wendepunkt bzw. Wiederaufnahme nach Pause
      ups.push([now, y]);
      if (state === 'hidden' && (y <= natTop + h || ups[0][1] - y >= SHOW_UP_PX)) setState('shown', true);
    }
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(handle); }
  // Capture faengt auch den Scroll von .page-wrapper; Scrolls in Slidern/Menues bleiben aussen vor
  document.addEventListener('scroll', function (e) { if (e.target === document || e.target === pw) schedule(); }, { capture: true, passive: true });
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { measure(); schedule(); }, 100); }, { passive: true });
  measure();
  handle();
})();

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alb-installation"] && !Shopify.designMode) return;
  try {
    
  /* Banner-Video: Autoplay-Loop bei prefers-reduced-motion anhalten (steht
     dann als Standbild auf dem ersten Frame). */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.alb-inst-banner-video').forEach(function (v) {
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (e) {}
    });
  }

  /* Banner-Video Desktop/Mobil: die native <source media>-Wahl passiert nur
     einmal beim Laden und nie wieder. Hier bei Mismatch korrigieren (z. B.
     Prerender) und beim Wechsel über den Breakpoint (Tablet-Rotation) neu
     zuweisen. Ohne JS bleibt die native Wahl aktiv. */
  (function () {
    if (!window.matchMedia) return;
    var mqDesktop = window.matchMedia('(min-width: 750px)');
    function applyBannerVideoSource() {
      document.querySelectorAll('.alb-inst-banner-video[data-video-desktop][data-video-mobile]').forEach(function (v) {
        var want = mqDesktop.matches ? v.getAttribute('data-video-desktop') : v.getAttribute('data-video-mobile');
        var abs;
        try { abs = new URL(want, document.baseURI).href; } catch (e) { return; }
        if (v.currentSrc === abs || v.getAttribute('src') === want) return;
        var resume = !v.paused || v.hasAttribute('autoplay');
        v.src = want;
        v.load();
        if (resume) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }
    applyBannerVideoSource();
    mqDesktop.addEventListener('change', applyBannerVideoSource);
    /* Fallback für WebViews, in denen der MediaQuery-Change nicht feuert. */
    var albInstResizeT;
    window.addEventListener('resize', function () {
      clearTimeout(albInstResizeT);
      albInstResizeT = setTimeout(applyBannerVideoSource, 200);
    });
  })();

  /* Click-to-load Video-Facade: lädt den YouTube(-nocookie)-iframe erst nach
     Klick -> keine externen Requests/Cookies vor Einwilligung. Guarded. */
  if (!customElements.get('alb-video-facade')) {
    customElements.define('alb-video-facade', class extends HTMLElement {
      connectedCallback() {
        var btn = this.querySelector('.alb-inst-facade');
        var embed = this.getAttribute('data-embed');
        if (!btn || !embed) return;
        var self = this;
        btn.addEventListener('click', function () {
          /* Box-Größe des Vorschaubilds festhalten: in der Bildhöhe „Natürlich" hat die Facade
             keine eigene Höhe – ohne Poster fiel der Iframe auf die Browser-Standardhöhe (150 px)
             zurück und das Video wurde winzig. Gemessenes Seitenverhältnis als Inline-Stil
             (schlägt die Section-Regeln), Iframe füllt die Box absolut. */
          var r = self.getBoundingClientRect();
          if (r.width > 0 && r.height > 0) {
            self.style.aspectRatio = Math.round(r.width) + ' / ' + Math.round(r.height);
            self.style.height = 'auto';
          }
          var iframe = document.createElement('iframe');
          iframe.src = embed;
          iframe.setAttribute('title', 'Video');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('loading', 'lazy');
          self.innerHTML = '';
          self.appendChild(iframe);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alb-reviews-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('alb-reviews-list')) { return; }
    class AlbReviewsList extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.items = Array.prototype.slice.call(this.querySelectorAll('.alb-rvl-item'));
        this.step = parseInt(this.getAttribute('data-step') || '5', 10) || 5;
        this.mode = this.getAttribute('data-nav') === 'pages' ? 'pages' : 'more';
        this.total = parseInt(this.getAttribute('data-total') || '0', 10) || 0;
        this.distClick = this.getAttribute('data-dist-click') || 'filter';
        this.limit = this.step;
        this.page = 1;
        this.filter = 0;
        this.modal = null;
        this.moreBtn = this.querySelector('[data-rvl-more]');
        this.emptyEl = this.querySelector('[data-rvl-empty]');
        this.resetBtn = this.querySelector('[data-rvl-reset]');
        this.filterBtns = Array.prototype.slice.call(this.querySelectorAll('button[data-rvl-filter]'));
        this.pager = this.querySelector('[data-rvl-pager]');
        this.pagerPages = this.pager ? this.pager.querySelector('[data-rvl-pages]') : null;
        this.prevBtn = this.pager ? this.pager.querySelector('[data-rvl-prev]') : null;
        this.nextBtn = this.pager ? this.pager.querySelector('[data-rvl-next]') : null;

        /* Zweistufiger Link (list_nav = more): laedt weitere geladene Eintraege nach und
           wird, sobald alle sichtbar sind, zum Popup-Link ueber ALLE Bewertungen. */
        if (this.moreBtn) {
          this.moreBtn.addEventListener('click', function () {
            if (self.moreBtn.getAttribute('data-state') === 'all') {
              if (self.modal && typeof self.modal.open === 'function') { self.modal.open(self.moreBtn); }
              return;
            }
            self.limit += self.step;
            self.render();
          });
        }
        /* Seitenzahlen (list_nav = pages): Vor/Zurueck + Nummern, Wechsel scrollt zum Listenanfang. */
        if (this.pager) {
          this.pager.addEventListener('click', function (e) {
            var b = e.target.closest('[data-rvl-page]');
            if (b) { self.goto(parseInt(b.getAttribute('data-rvl-page'), 10)); }
          });
          if (this.prevBtn) { this.prevBtn.addEventListener('click', function () { self.goto(self.page - 1); }); }
          if (this.nextBtn) { this.nextBtn.addEventListener('click', function () { self.goto(self.page + 1); }); }
        }

        /* Bewertungs-Popup (snippets/alb-reviews-modal): eigenes Popup der Section
           (data-modal) oder das der Produkt-Section auf der PDP. Wird fuer den Button
           "Alle Bewertungen anzeigen" UND fuer den Balken-Klick (dist_click = popup)
           gebraucht. Der Button bleibt hidden, solange kein Popup auf der Seite ist. */
        var allBtn = this.querySelector('[data-rvl-all]');
        var ownId = this.getAttribute('data-modal') || (allBtn && allBtn.getAttribute('aria-controls')) || '';
        if (window.customElements && customElements.whenDefined) {
          customElements.whenDefined('alb-reviews-modal').then(function () {
            var modal = (ownId && document.getElementById(ownId)) || document.querySelector('alb-reviews-modal');
            if (!modal) { return; }
            self.modal = modal;
            if (self.moreBtn) { self.render(); }
            if (allBtn) {
              allBtn.hidden = false;
              /* Eigenes Popup bindet den Klick selbst ueber aria-controls */
              if (!allBtn.getAttribute('aria-controls')) { allBtn.addEventListener('click', function () { modal.open(allBtn); }); }
            }
          });
        }

        /* Sterne-Verteilung: Klick auf eine Zeile -> Popup mit vorbelegtem Sterne-Filter
           (alle Bewertungen dieser Sternzahl) oder, ohne erreichbares Popup bzw. bei
           dist_click = filter, Filter auf die geladene Liste (erneuter Klick / "Filter
           loeschen" hebt auf). */
        this.filterBtns.forEach(function (b) {
          b.addEventListener('click', function () {
            var v = parseInt(b.getAttribute('data-rvl-filter'), 10);
            if (self.distClick === 'popup' && self.modal && typeof self.modal.open === 'function') {
              self.modal.open(b, { rating: v });
              return;
            }
            self.filter = (self.filter === v) ? 0 : v;
            self.page = 1;
            self.limit = self.step;
            self.render();
          });
        });
        if (this.resetBtn) {
          this.resetBtn.addEventListener('click', function () { self.filter = 0; self.page = 1; self.limit = self.step; self.render(); });
        }

        /* Kundenfotos/-videos: Thumbnail-Klick oeffnet das native dialog-Lightbox —
           Foto als <img> (data-full), Video als <video> (data-video, MP4 vom
           Reviews.io-CDN, startet nach dem Klick, stoppt beim Schliessen). */
        var lb = this.querySelector('[data-rvl-lightbox]');
        if (lb && typeof lb.showModal === 'function') {
          var lbImg = lb.querySelector('img');
          var lbVideo = lb.querySelector('video');
          this.addEventListener('click', function (e) {
            var ph = e.target.closest('.alb-rvl-photo');
            if (!ph || !self.contains(ph)) { return; }
            var video = ph.getAttribute('data-video');
            if (video && lbVideo) {
              lbImg.hidden = true; lbImg.removeAttribute('src');
              lbVideo.hidden = false; lbVideo.src = video;
              lb.showModal();
              var p = lbVideo.play(); if (p && p.catch) { p.catch(function () {}); }
            } else {
              if (lbVideo) { lbVideo.hidden = true; }
              var thumb = ph.querySelector('img');
              lbImg.hidden = false;
              lbImg.src = ph.getAttribute('data-full');
              lbImg.alt = thumb ? thumb.alt : '';
              lb.showModal();
            }
          });
          lb.addEventListener('click', function (e) {
            if (e.target === lb || e.target.closest('[data-rvl-lightbox-close]')) { lb.close(); }
          });
          lb.addEventListener('close', function () {
            lbImg.removeAttribute('src');
            if (lbVideo) { lbVideo.pause(); lbVideo.removeAttribute('src'); lbVideo.load(); lbVideo.hidden = true; }
          });
        }

        /* Service-Antworten: "Mehr lesen" klappt die gekuerzte Antwort auf und wieder zu. */
        this.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-rvl-reply-more]');
          if (!btn || !self.contains(btn)) { return; }
          var box = btn.closest('.alb-rvl-reply');
          var open = !box.classList.contains('is-open');
          box.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', String(open));
          btn.textContent = open ? 'Weniger anzeigen' : 'Mehr lesen';
        });
        this._onResize = function () {
          window.clearTimeout(self._rt);
          self._rt = window.setTimeout(function () { self.measureReplies(true); }, 150);
        };
        window.addEventListener('resize', this._onResize);

        this.render();
      }
      disconnectedCallback() {
        if (this._onResize) { window.removeEventListener('resize', this._onResize); }
      }
      /* Zeigt "Mehr lesen" nur bei tatsaechlich abgeschnittenem Text. Gemessen wird nur an
         sichtbaren, zugeklappten Antworten; versteckte Eintraege (hidden) haben keine Hoehe. */
      measureReplies(force) {
        var boxes = this.querySelectorAll('.alb-rvl-reply');
        Array.prototype.forEach.call(boxes, function (box) {
          var btn = box.querySelector('[data-rvl-reply-more]');
          if (!btn || box.classList.contains('is-open')) { return; }
          if (box.getAttribute('data-measured') && !force) { return; }
          var txt = box.querySelector('.alb-rvl-reply-text');
          if (!txt || txt.offsetParent === null) { return; }
          btn.hidden = !(txt.scrollHeight > txt.clientHeight + 1);
          box.setAttribute('data-measured', '1');
        });
      }
      goto(n) {
        var pages = this.pageCount();
        n = Math.max(1, Math.min(pages, n));
        if (n === this.page) { return; }
        this.page = n;
        this.render();
        var top = this.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
      matchingItems() {
        var f = this.filter;
        return this.items.filter(function (li) { return !f || parseInt(li.getAttribute('data-r'), 10) === f; });
      }
      pageCount() {
        return Math.max(1, Math.ceil(this.matchingItems().length / this.step));
      }
      render() {
        var self = this, f = this.filter;
        var list = this.matchingItems();
        var start, end;
        if (this.mode === 'pages') {
          var pages = Math.max(1, Math.ceil(list.length / this.step));
          if (this.page > pages) { this.page = pages; }
          start = (this.page - 1) * this.step;
          end = start + this.step;
        } else {
          start = 0;
          end = this.limit;
        }
        this.items.forEach(function (li) { li.hidden = true; });
        list.forEach(function (li, i) { li.hidden = !(i >= start && i < end); });
        if (this.moreBtn) { this.renderMore(list.length > end); }
        if (this.pager) { this.renderPager(list.length); }
        this.measureReplies(false);
        if (this.emptyEl) { this.emptyEl.hidden = !(f && list.length === 0); }
        if (this.resetBtn) { this.resetBtn.hidden = !f; }
        this.filterBtns.forEach(function (b) {
          if (b.hasAttribute('aria-pressed')) {
            b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-rvl-filter'), 10) === f));
          }
        });
      }
      /* Zustand des Textlinks: "more" solange geladene Eintraege fehlen, danach "all"
         (Popup ueber alle Bewertungen) — und aus, wenn es nichts mehr zu zeigen gibt. */
      renderMore(hasMoreLoaded) {
        var b = this.moreBtn;
        if (this.mode !== 'more') { b.hidden = true; return; }
        var label = b.querySelector('[data-rvl-more-label]') || b;
        if (hasMoreLoaded) {
          b.hidden = false;
          b.setAttribute('data-state', 'more');
          label.textContent = b.getAttribute('data-label-more');
          b.removeAttribute('aria-haspopup');
          return;
        }
        var canPopup = !!(this.modal && typeof this.modal.open === 'function');
        var moreInShop = this.total > this.items.length;
        if (canPopup && moreInShop && !this.filter) {
          b.hidden = false;
          b.setAttribute('data-state', 'all');
          label.textContent = b.getAttribute('data-label-all');
          b.setAttribute('aria-haspopup', 'dialog');
        } else {
          b.hidden = true;
        }
      }
      renderPager(total) {
        var pages = Math.max(1, Math.ceil(total / this.step));
        this.pager.hidden = this.mode !== 'pages' || pages <= 1;
        if (this.pager.hidden) { return; }
        var p = this.page, nums = [], i;
        if (pages <= 7) {
          for (i = 1; i <= pages; i++) { nums.push(i); }
        } else {
          nums.push(1);
          if (p > 3) { nums.push('gap'); }
          for (i = Math.max(2, p - 1); i <= Math.min(pages - 1, p + 1); i++) { nums.push(i); }
          if (p < pages - 2) { nums.push('gap'); }
          nums.push(pages);
        }
        var html = '';
        nums.forEach(function (n) {
          if (n === 'gap') { html += '<span class="alb-rvl-pager-gap" aria-hidden="true">…</span>'; return; }
          html += '<button type="button" class="alb-rvl-pager-btn" data-rvl-page="' + n + '"' +
            (n === p ? ' aria-current="page"' : '') + ' aria-label="Seite ' + n + '">' + n + '</button>';
        });
        this.pagerPages.innerHTML = html;
        if (this.prevBtn) { this.prevBtn.disabled = p <= 1; }
        if (this.nextBtn) { this.nextBtn.disabled = p >= pages; }
      }
    }
    window.customElements.define('alb-reviews-list', AlbReviewsList);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alb-reviews-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('alb-reviews-slider')) { return; }
    class AlbReviewsSlider extends HTMLElement {
      connectedCallback() {
        this.vp = this.querySelector('.alb-rvs-viewport');
        if (!this.vp) { return; }
        var prev = this.querySelector('.alb-rvs-nav--prev');
        var next = this.querySelector('.alb-rvs-nav--next');
        var pause = this.querySelector('.alb-rvs-pause');
        var self = this;
        if (prev) { prev.hidden = false; prev.addEventListener('click', function () { self.step(-1); }); }
        if (next) { next.hidden = false; next.addEventListener('click', function () { self.step(1); }); }

        /* "Alle Bewertungen anzeigen" -> oeffnet das Bewertungs-Popup
           (snippets/alb-reviews-modal). Eigenes Popup der Section: Button
           traegt aria-controls, die Web Component bindet den Klick selbst.
           Sonst (PDP) das Popup der Produkt-Section; der Button bleibt
           hidden, solange kein Popup-Element auf der Seite existiert. */
        var allBtn = this.querySelector('[data-rvs-all]');
        if (allBtn && window.customElements && customElements.whenDefined) {
          customElements.whenDefined('alb-reviews-modal').then(function () {
            var ownId = allBtn.getAttribute('aria-controls');
            var modal = (ownId && document.getElementById(ownId)) || document.querySelector('alb-reviews-modal');
            if (!modal) { return; }
            allBtn.hidden = false;
            if (!ownId) { allBtn.addEventListener('click', function () { modal.open(allBtn); }); }
          });
        }

        /* Kundenfotos: Klick auf ein Thumbnail oeffnet das native dialog-
           Lightbox der Section mit der grossen Version (data-full). */
        var lb = this.querySelector('[data-rvs-lightbox]');
        if (lb && typeof lb.showModal === 'function') {
          var lbImg = lb.querySelector('img');
          this.addEventListener('click', function (e) {
            var ph = e.target.closest('.alb-rvs-photo');
            if (!ph || !self.contains(ph)) { return; }
            var thumb = ph.querySelector('img');
            lbImg.src = ph.getAttribute('data-full');
            lbImg.alt = thumb ? thumb.alt : '';
            lb.showModal();
          });
          lb.addEventListener('click', function (e) {
            if (e.target === lb || e.target.closest('[data-rvs-lightbox-close]')) { lb.close(); }
          });
          lb.addEventListener('close', function () { lbImg.removeAttribute('src'); });
        }

        /* Einzel-Bewertung im Popup: Klick auf die Kachel (nicht auf Fotos/Links/Buttons)
           oder auf „Mehr lesen" klont die Kachel in den Dialog und setzt den Volltext
           aus data-rv-text ein. Textauswahl per Maus öffnet nichts. */
        var rvDialog = this.querySelector('[data-rvs-review]');
        if (rvDialog && typeof rvDialog.showModal === 'function') {
          var rvBody = rvDialog.querySelector('[data-rvs-review-body]');
          this.addEventListener('click', function (e) {
            if (rvDialog.contains(e.target)) { return; }
            if (e.target.closest('a, .alb-rvs-photo, .alb-rvs-nav, .alb-rvs-pause, [data-rvs-all]')) { return; }
            var card = e.target.closest('.alb-rvs-track > .alb-rvs-card');
            if (!card || !self.contains(card)) { return; }
            var sel = window.getSelection && window.getSelection();
            if (sel && String(sel).length > 0 && !e.target.closest('.alb-rvs-more')) { return; }
            var clone = card.cloneNode(true);
            clone.classList.remove('alb-rvs-card--popup');
            clone.removeAttribute('data-rv-text');
            var txt = clone.querySelector('.alb-rvs-text');
            if (txt && card.getAttribute('data-rv-text')) { txt.textContent = card.getAttribute('data-rv-text'); }
            rvBody.innerHTML = '';
            rvBody.appendChild(clone);
            rvDialog.showModal();
          });
          rvDialog.addEventListener('click', function (e) {
            if (e.target === rvDialog || e.target.closest('[data-rvs-review-close]')) { rvDialog.close(); }
          });
          rvDialog.addEventListener('close', function () { rvBody.innerHTML = ''; });
          /* Esc explizit (falls ein globaler Keydown-Handler das native cancel unterdrueckt) */
          rvDialog.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); rvDialog.close(); } });
        }
        this.delay = parseInt(this.getAttribute('data-autoplay') || '0', 10);
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.delay > 0 && !reduced && pause) {
          pause.hidden = false;
          this.userPaused = false;
          this.hovering = false;
          pause.addEventListener('click', function () {
            self.userPaused = !self.userPaused;
            pause.setAttribute('aria-pressed', String(self.userPaused));
            pause.querySelector('.alb-rvs-pause-label').textContent = self.userPaused ? 'Abspielen' : 'Pause';
          });
          this.addEventListener('pointerenter', function () { self.hovering = true; });
          this.addEventListener('pointerleave', function () { self.hovering = false; });
          this.addEventListener('focusin', function () { self.hovering = true; });
          this.addEventListener('focusout', function () { self.hovering = false; });
          this.inView = false;
          this.io = new IntersectionObserver(function (entries) {
            self.inView = entries[0].isIntersecting;
          }, { threshold: 0.3 });
          this.io.observe(this);
          this.timer = window.setInterval(function () {
            if (self.userPaused || self.hovering || !self.inView || document.hidden) { return; }
            self.step(1, true);
          }, this.delay);
        }
      }
      disconnectedCallback() {
        if (this.timer) { window.clearInterval(this.timer); }
        if (this.io) { this.io.disconnect(); }
      }
      step(dir, wrap) {
        var vp = this.vp;
        var card = vp.querySelector('.alb-rvs-card');
        if (!card) { return; }
        var gap = 20;
        var w = card.getBoundingClientRect().width + gap;
        var end = vp.scrollWidth - vp.clientWidth - 4;
        if (dir > 0 && vp.scrollLeft >= end) {
          vp.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (dir < 0 && vp.scrollLeft <= 4) {
          if (wrap) { vp.scrollTo({ left: end, behavior: 'smooth' }); }
        } else {
          vp.scrollBy({ left: dir * w, behavior: 'smooth' });
        }
      }
    }
    window.customElements.define('alb-reviews-slider', AlbReviewsSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ratgeber-frag-ki"] && !Shopify.designMode) return;
  try {
    
  /* Lazy vanilla Web Component – belegt die KI-Buttons mit Frage + Artikel-Link.
     Kein externes JS, kein Tracking. Ohne JS bleiben die serverseitig
     vorbelegten Standard-Links (q-Parameter) aktiv. */
  if (!customElements.get('alb-rg-frag-ki')) {
    customElements.define('alb-rg-frag-ki', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-input]');
        this.links = this.querySelectorAll('[data-base]');
        if (!this.input || !this.links.length) return;
        this.articleUrl = this.getAttribute('data-article-url') || '';
        this.suffix = this.getAttribute('data-suffix') || '';
        this._sync = this.sync.bind(this);
        this.input.addEventListener('input', this._sync);
        this.links.forEach((a) => {
          a.addEventListener('pointerdown', this._sync);
          a.addEventListener('focus', this._sync);
        });
        this.sync();
      }
      sync() {
        const q = (this.input.value || this.input.placeholder || '').trim();
        const prompt = q + '\n\n' + this.suffix + ' ' + this.articleUrl;
        const enc = encodeURIComponent(prompt);
        this.links.forEach((a) => { a.href = a.getAttribute('data-base') + enc; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ratgeber-related"] && !Shopify.designMode) return;
  try {
    
  /* Lazy vanilla Web Component – Pfeil-Navigation für den Karten-Track.
     Kein externes JS/Framework. Ohne diese Definition scrollt das Band
     nativ; die Pfeile bleiben dann versteckt (hidden). */
  if (!customElements.get('alb-rg-carousel')) {
    customElements.define('alb-rg-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-no-arrows')) return;
        this.track = this.querySelector('[data-track]');
        this.nav = this.querySelector('[data-nav]');
        if (!this.track || !this.nav) return;
        this.prev = this.nav.querySelector('[data-dir="-1"]');
        this.next = this.nav.querySelector('[data-dir="1"]');
        this._update = this.update.bind(this);
        this.nav.addEventListener('click', (e) => {
          const btn = e.target.closest('button[data-dir]');
          if (btn) this.track.scrollBy({ left: this.step() * Number(btn.dataset.dir), behavior: 'smooth' });
        });
        this.track.addEventListener('scroll', this._update, { passive: true });
        window.addEventListener('resize', this._update);
        this.update();
      }
      disconnectedCallback() { window.removeEventListener('resize', this._update); }
      step() {
        const card = this.track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 24 : this.track.clientWidth;
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.nav.hidden = max < 4;
        if (this.prev) this.prev.disabled = this.track.scrollLeft < 4;
        if (this.next) this.next.disabled = this.track.scrollLeft > max - 4;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ratgeber-uebersicht"] && !Shopify.designMode) return;
  try {
    
  /* Lazy vanilla Web Component – Pfeil-Navigation. Ohne diese Definition scrollt
     das Band nativ per Touch/Trackpad; die Pfeile bleiben versteckt (hidden). */
  if (!customElements.get('alb-rgu-carousel')) {
    customElements.define('alb-rgu-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-no-arrows')) return;
        this.track = this.querySelector('[data-track]');
        this.nav = this.querySelector('[data-nav]');
        if (!this.track || !this.nav) return;
        this.prev = this.nav.querySelector('[data-dir="-1"]');
        this.next = this.nav.querySelector('[data-dir="1"]');
        this._update = this.update.bind(this);
        this.nav.addEventListener('click', (e) => {
          const btn = e.target.closest('button[data-dir]');
          if (btn) this.track.scrollBy({ left: this.step() * Number(btn.dataset.dir), behavior: 'smooth' });
        });
        this.track.addEventListener('scroll', this._update, { passive: true });
        window.addEventListener('resize', this._update);
        this.update();
      }
      disconnectedCallback() { window.removeEventListener('resize', this._update); }
      step() {
        const card = this.track.firstElementChild;
        const gap = parseInt(getComputedStyle(this.track).columnGap) || 24;
        return card ? (card.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(this.track.clientWidth / (card.getBoundingClientRect().width + gap))) : this.track.clientWidth;
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.nav.hidden = max < 4;
        if (this.prev) this.prev.disabled = this.track.scrollLeft < 4;
        if (this.next) this.next.disabled = this.track.scrollLeft > max - 4;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
